import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/secret-card/default.png")